module.exports = __webpack_public_path__ + "static/img/product-1.75bbcec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/product-1.png
// module id = Ohf8
// module chunks = 49